export const marketplaceQueryKeys = {
  dashboard: ["marketplace", "dashboard"],
  listings: (filters = {}) => ["marketplace", "listings", filters],
  listing: (id) => ["marketplace", "listing", id],
  reviews: (filters = {}) => ["marketplace", "reviews", filters],
  negotiation: (id) => ["marketplace", "negotiation", id],
  deal: (id) => ["marketplace", "deal", id],
  purchaseOrder: (id) => ["marketplace", "purchase-order", id],
};
